<template>
  <div class="pa-4">
    <!-- Header / Top Bar -->
    <div class="d-flex flex-wrap align-center justify-space-between mb-4">
      <v-btn @click="$router.back()" class="back-btn">
        <v-icon left>mdi-arrow-left</v-icon>
        VOLVER
      </v-btn>
    </div>

    <!-- Modales de Instalación y Retiro -->
    <Nuevo
      :dialognuevo="dialognuevo"
      @dialognuevo="dialognuevo = $event"
      :Item="seleccionado"
      @instalarneumatico="instalarneumatico"
    />
    <Retiro
      :dialogretiro="dialogretiro"
      @dialogretiro="dialogretiro = $event"
      :Item="seleccionado"
      @desinstalarneumatico="desinstalarneumatico"
    />

    <!-- Tarjeta de Datos del Vehículo y Operación -->
    <v-card class="rounded-lg elevation-2 overflow-hidden mb-5">
      <v-toolbar color="secondary" dark flat dense height="50" class="px-3">
        <v-icon left small>mdi-truck-outline</v-icon>
        <span class="text-subtitle-1 font-weight-bold">
          Datos del Vehículo y Parámetros de Operación
        </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1 btn-circle-tooltip"
              icon
              dark
              target="_blank"
              :href="global.helpdesk_url + 'mant_inf_vehiculos_instalar'"
              v-on="on"
            >
              <v-icon size="25" color="amber lighten-2"
                >mdi-help-circle-outline</v-icon
              >
            </v-btn>
          </template>
          <span>¿Necesitas ayuda?</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text class="pa-4 pa-md-5">
        <v-row dense>
          <!-- N° de Placa -->
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-text-field
              label="N° de Placa"
              hide-details="auto"
              v-model="ItemInstalacion.placa"
              readonly
              outlined
              dense
              prepend-inner-icon="mdi-car"
            ></v-text-field>
          </v-col>

          <!-- Código -->
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-text-field
              label="Código del Vehículo"
              hide-details="auto"
              v-model="ItemInstalacion.codigo"
              readonly
              outlined
              dense
              prepend-inner-icon="mdi-barcode"
            ></v-text-field>
          </v-col>

          <!-- Configuración -->
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-text-field
              label="Configuración"
              hide-details="auto"
              v-model="ItemInstalacion.configuracion"
              readonly
              outlined
              dense
              prepend-inner-icon="mdi-axis-arrow"
            ></v-text-field>
          </v-col>

          <!-- N° Neumáticos -->
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-text-field
              label="N° Neumáticos"
              hide-details="auto"
              v-model="ItemInstalacion.numneumaticos"
              readonly
              outlined
              dense
              prepend-inner-icon="mdi-tire"
            ></v-text-field>
          </v-col>

          <!-- Fecha Instalación / Retiro -->
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-text-field
              type="date"
              label="Fecha Instalación / Retiro *"
              hide-details="auto"
              id="fechainstalacion"
              v-model="ItemInstalacion.fechainstalacion"
              focus
              @change="onValidarDuplicidad(), onValidarFecha()"
              required
              outlined
              dense
              prepend-inner-icon="mdi-calendar"
            ></v-text-field>
            <span
              class="red--text caption mt-1 d-block"
              v-if="mensajevalidacionfecha"
            >
              {{ mensajevalidacionfecha }}
            </span>
          </v-col>

          <!-- Tipo Costo / Kilometraje u Horas -->
          <div hidden>{{ labelKilometrosInstalacion() }}</div>
          <v-col cols="12" sm="6" md="3" class="pa-2">
            <v-text-field
              type="number"
              :label="labelKM + ' *'"
              hide-details="auto"
              v-model="ItemInstalacion.kilometraje"
              @change="onValidarDuplicidad(), onValidarKm()"
              required
              outlined
              dense
              prepend-inner-icon="mdi-speedometer"
            ></v-text-field>
            <span
              class="red--text caption mt-1 d-block"
              v-if="mensajevalidacionkm"
            >
              {{ mensajevalidacionkm }}
            </span>
          </v-col>
        </v-row>

        <!-- Alerta de validación de duplicidad -->
        <v-alert
          v-if="
            validacioncorrectaduplicidad &&
            mensajevalidacionduplicidad != 'Error de validación' &&
            mensajevalidacionfecha != 'Error de validación'
          "
          dense
          class="alerta-duplicidad mt-4 mb-0"
        >
          <template v-slot:prepend>
            <div class="alerta-duplicidad-badge mr-3">
              <v-icon color="#713F12" size="24">mdi-alert</v-icon>
            </div>
          </template>
          <div class="d-flex flex-column">
            <span class="alerta-duplicidad-titulo">
              Advertencia de Duplicidad
            </span>
            <span class="alerta-duplicidad-texto">
              {{ mensajevalidacionduplicidad }}
            </span>
          </div>
        </v-alert>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Barra de Acciones del Registro -->
      <v-card-actions class="bg-actions pa-3 px-4 d-flex align-center">
        <span class="text-caption grey--text text--darken-1 d-none d-sm-inline">
          <v-icon small color="info" class="mr-1"
            >mdi-information-outline</v-icon
          >
          Ingrese fecha y kilometraje para habilitar el esquema interactivo de
          neumáticos
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="grey darken-1"
          text
          class="text-capitalize px-4"
          @click="cancelarInstalacion()"
        >
          <v-icon left small>mdi-close</v-icon>
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Indicador de Carga -->
    <div
      v-if="loader"
      class="d-flex flex-column align-center justify-center my-6"
    >
      <vue-loaders name="ball-beat" color="#009688" scale="1"></vue-loaders>
      <span class="caption grey--text text--darken-1 mt-2 font-weight-medium">
        Cargando esquema de neumáticos del vehículo...
      </span>
    </div>

    <!-- SECCIÓN INTERACTIVA DE INSTALACIÓN -->
    <v-slide-y-transition>
      <v-row v-if="mostrarNeumaticos" class="mt-2">
        <!-- Columna Izquierda: Neumáticos Disponibles en Almacén -->
        <v-col cols="12" md="4">
          <v-card
            class="rounded-lg elevation-2 overflow-hidden fill-height d-flex flex-column"
          >
            <v-toolbar
              color="secondary"
              dark
              dense
              flat
              height="48"
              class="px-3"
            >
              <v-icon left small>mdi-warehouse</v-icon>
              <span class="text-subtitle-2 font-weight-bold"
                >Neumáticos Disponibles</span
              >
              <v-spacer></v-spacer>
              <v-chip
                x-small
                color="white"
                text-color="secondary"
                class="font-weight-bold"
              >
                {{ total }} en almacén
              </v-chip>
            </v-toolbar>

            <!-- Banner de selección activa -->
            <v-slide-y-transition>
              <div
                v-if="neumaticoSelected"
                class="pa-2 px-3 teal lighten-5 d-flex align-center justify-space-between"
                style="border-bottom: 1px solid #b2dfdb"
              >
                <div class="d-flex align-center text-truncate">
                  <v-icon small color="teal" class="mr-1"
                    >mdi-check-circle</v-icon
                  >
                  <span
                    class="caption font-weight-bold teal--text text--darken-4 text-truncate"
                  >
                    Seleccionado: {{ neumaticoSelected.num_serie }}
                  </span>
                </div>
                <v-btn
                  icon
                  x-small
                  color="teal darken-3"
                  @click="deshabilitarohabilitarneumatico(false)"
                  title="Deseleccionar"
                >
                  <v-icon x-small>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-slide-y-transition>

            <div class="flex-grow-1">
              <TablaNeumaticos
                v-if="mostrarTablaInstalacion"
                @enviarDatos="enviarDatos"
                :Cabecera="Cabecera"
                :Items="ItemsNeumaticos"
                :MostrarImagen="false"
                :data="data"
                :total="total"
                :per_page="per_page"
                :from="from"
                :to="to"
                :page="page"
                @getNeumaticos="cargarDatosNeumaticosPosicionHistorial"
                :loading="loading"
              />
            </div>
          </v-card>
        </v-col>

        <!-- Columna Derecha: Esquema Gráfico del Vehículo -->
        <v-col cols="12" md="8">
          <v-card class="rounded-lg elevation-2 overflow-hidden">
            <v-toolbar
              color="secondary"
              dark
              dense
              flat
              height="48"
              class="px-3"
            >
              <v-icon left small>mdi-axis-arrow</v-icon>
              <span class="text-subtitle-2 font-weight-bold">
                Esquema de Instalación en el Vehículo
              </span>
              <v-spacer></v-spacer>
              <span class="caption text-white opacity-80 d-none d-sm-inline">
                Haga clic en una posición para instalar o retirar
              </span>
            </v-toolbar>

            <v-card-text class="pa-3 pa-md-5" style="background-color: #fcfdfd">
              <div class="schematic-container pa-3 pa-md-4 rounded-lg">
                <div class="table-responsive d-flex justify-center">
                  <table class="table chassis-table">
                    <tbody>
                      <!-- Fila 1 -->
                      <tr>
                        <td class="empty-cell"></td>
                        <td
                          v-for="pos in fila_1"
                          :key="pos"
                          class="text-center"
                        >
                          <v-btn
                            width="106"
                            height="46"
                            class="pa-0 tire-pos-btn elevation-1"
                            :class="{
                              'tire-installed':
                                existeposicion(pos, ItemsPosicion) &&
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos != '-',
                              'tire-empty':
                                existeposicion(pos, ItemsPosicion) &&
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos == '-',
                              'tire-new-install':
                                arrayneumaticoposicioninstalar.some(
                                  (x) => x.ubicacion === pos,
                                ),
                              'tire-can-install':
                                neumaticoSelected != null &&
                                existeposicion(pos, ItemsPosicion) &&
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos == '-',
                            }"
                            v-if="existeposicion(pos, ItemsPosicion)"
                            @click="
                              seleccionarposicion(
                                pos,
                                existeposicion(pos, ItemsPosicion),
                              )
                            "
                          >
                            <div
                              v-if="
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos != '-'
                              "
                              class="position-relative w-100 h-100 d-flex align-center justify-center"
                            >
                              <Imagen
                                :num_serie="
                                  existeposicion(pos, ItemsPosicion).num_serie
                                "
                              />
                              <span
                                v-if="
                                  arrayneumaticoposicioninstalar.some(
                                    (x) => x.ubicacion === pos,
                                  )
                                "
                                class="badge-new-install"
                              >
                                NUEVO
                              </span>
                            </div>
                            <div
                              v-else
                              class="empty-pos-box d-flex flex-column align-center justify-center"
                            >
                              <span class="empty-pos-label font-weight-bold">
                                {{ "P" + ItemsPosicion[pos].posicion }}
                              </span>
                              <span
                                v-if="neumaticoSelected != null"
                                class="empty-install-hint"
                              >
                                Instalar
                              </span>
                            </div>
                          </v-btn>
                          <div v-else class="empty-cell">&nbsp;</div>
                        </td>
                      </tr>

                      <!-- Fila 2 -->
                      <tr>
                        <td
                          v-for="pos in fila_2"
                          :key="pos"
                          class="text-center"
                        >
                          <v-btn
                            v-if="existeposicion(pos, ItemsPosicion)"
                            width="106"
                            height="46"
                            class="pa-0 tire-pos-btn elevation-1"
                            :class="{
                              'tire-installed':
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos != '-',
                              'tire-empty':
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos == '-',
                              'tire-new-install':
                                arrayneumaticoposicioninstalar.some(
                                  (x) => x.ubicacion === pos,
                                ),
                              'tire-can-install':
                                neumaticoSelected != null &&
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos == '-',
                            }"
                            @click="
                              seleccionarposicion(
                                pos,
                                existeposicion(pos, ItemsPosicion),
                              )
                            "
                          >
                            <div
                              v-if="
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos != '-'
                              "
                              class="position-relative w-100 h-100 d-flex align-center justify-center"
                            >
                              <Imagen
                                :num_serie="
                                  existeposicion(pos, ItemsPosicion).num_serie
                                "
                              />
                              <span
                                v-if="
                                  arrayneumaticoposicioninstalar.some(
                                    (x) => x.ubicacion === pos,
                                  )
                                "
                                class="badge-new-install"
                              >
                                NUEVO
                              </span>
                            </div>
                            <div
                              v-else
                              class="empty-pos-box d-flex flex-column align-center justify-center"
                            >
                              <span class="empty-pos-label font-weight-bold">
                                {{ "P" + ItemsPosicion[pos].posicion }}
                              </span>
                              <span
                                v-if="neumaticoSelected != null"
                                class="empty-install-hint"
                              >
                                Instalar
                              </span>
                            </div>
                          </v-btn>
                          <div v-else class="empty-cell">&nbsp;</div>
                        </td>
                      </tr>

                      <!-- Línea Central del Chasis -->
                      <tr class="chassis-spine-row">
                        <td colspan="6" class="py-3 px-2">
                          <div class="chassis-spine">
                            <span class="spine-label"
                              >CHASIS / LÍNEA CENTRAL</span
                            >
                          </div>
                        </td>
                      </tr>

                      <!-- Fila 3 -->
                      <tr>
                        <td
                          v-for="pos in fila_3"
                          :key="pos"
                          class="text-center"
                        >
                          <v-btn
                            v-if="existeposicion(pos, ItemsPosicion)"
                            width="106"
                            height="46"
                            class="pa-0 tire-pos-btn elevation-1"
                            :class="{
                              'tire-installed':
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos != '-',
                              'tire-empty':
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos == '-',
                              'tire-new-install':
                                arrayneumaticoposicioninstalar.some(
                                  (x) => x.ubicacion === pos,
                                ),
                              'tire-can-install':
                                neumaticoSelected != null &&
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos == '-',
                            }"
                            @click="
                              seleccionarposicion(
                                pos,
                                existeposicion(pos, ItemsPosicion),
                              )
                            "
                          >
                            <div
                              v-if="
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos != '-'
                              "
                              class="position-relative w-100 h-100 d-flex align-center justify-center"
                            >
                              <Imagen
                                :num_serie="
                                  existeposicion(pos, ItemsPosicion).num_serie
                                "
                              />
                              <span
                                v-if="
                                  arrayneumaticoposicioninstalar.some(
                                    (x) => x.ubicacion === pos,
                                  )
                                "
                                class="badge-new-install"
                              >
                                NUEVO
                              </span>
                            </div>
                            <div
                              v-else
                              class="empty-pos-box d-flex flex-column align-center justify-center"
                            >
                              <span class="empty-pos-label font-weight-bold">
                                {{ "P" + ItemsPosicion[pos].posicion }}
                              </span>
                              <span
                                v-if="neumaticoSelected != null"
                                class="empty-install-hint"
                              >
                                Instalar
                              </span>
                            </div>
                          </v-btn>
                          <div v-else class="empty-cell">&nbsp;</div>
                        </td>
                      </tr>

                      <!-- Fila 4 -->
                      <tr>
                        <td class="empty-cell"></td>
                        <td
                          v-for="pos in fila_4"
                          :key="pos"
                          class="text-center"
                        >
                          <v-btn
                            width="106"
                            height="46"
                            class="pa-0 tire-pos-btn elevation-1"
                            :class="{
                              'tire-installed':
                                existeposicion(pos, ItemsPosicion) &&
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos != '-',
                              'tire-empty':
                                existeposicion(pos, ItemsPosicion) &&
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos == '-',
                              'tire-new-install':
                                arrayneumaticoposicioninstalar.some(
                                  (x) => x.ubicacion === pos,
                                ),
                              'tire-can-install':
                                neumaticoSelected != null &&
                                existeposicion(pos, ItemsPosicion) &&
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos == '-',
                            }"
                            v-if="existeposicion(pos, ItemsPosicion)"
                            @click="
                              seleccionarposicion(
                                pos,
                                existeposicion(pos, ItemsPosicion),
                              )
                            "
                          >
                            <div
                              v-if="
                                existeposicion(pos, ItemsPosicion)
                                  .id_neumaticos != '-'
                              "
                              class="position-relative w-100 h-100 d-flex align-center justify-center"
                            >
                              <Imagen
                                :num_serie="
                                  existeposicion(pos, ItemsPosicion).num_serie
                                "
                              />
                              <span
                                v-if="
                                  arrayneumaticoposicioninstalar.some(
                                    (x) => x.ubicacion === pos,
                                  )
                                "
                                class="badge-new-install"
                              >
                                NUEVO
                              </span>
                            </div>
                            <div
                              v-else
                              class="empty-pos-box d-flex flex-column align-center justify-center"
                            >
                              <span class="empty-pos-label font-weight-bold">
                                {{ "P" + ItemsPosicion[pos].posicion }}
                              </span>
                              <span
                                v-if="neumaticoSelected != null"
                                class="empty-install-hint"
                              >
                                Instalar
                              </span>
                            </div>
                          </v-btn>
                          <div v-else class="empty-cell">&nbsp;</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Barra Inferior de Guardado y Resumen -->
              <div
                class="d-flex flex-wrap align-center justify-space-between mt-4 pa-3 rounded-lg bg-actions"
              >
                <div class="d-flex flex-wrap align-center">
                  <v-chip
                    small
                    outlined
                    color="teal"
                    class="font-weight-bold mr-2 mb-1"
                  >
                    <v-icon left small color="teal"
                      >mdi-arrow-down-bold-circle</v-icon
                    >
                    Instalados: {{ arrayneumaticoposicioninstalar.length }}
                  </v-chip>
                  <v-chip
                    small
                    outlined
                    color="orange darken-3"
                    class="font-weight-bold mb-1"
                  >
                    <v-icon left small color="orange darken-3"
                      >mdi-arrow-up-bold-circle</v-icon
                    >
                    Retirados: {{ arrayneumaticoposiciondesinstalar.length }}
                  </v-chip>
                </div>
                <v-btn
                  color="primary"
                  elevation="2"
                  class="text-capitalize px-5"
                  :disabled="
                    arrayneumaticoposicioninstalar.length == 0 &&
                    arrayneumaticoposiciondesinstalar.length == 0
                  "
                  @click="openModalOpcionesParaGuardar()"
                  :loading="loadingGuardar"
                >
                  <v-icon left small>mdi-content-save</v-icon>
                  Guardar Cambios
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-slide-y-transition>

    <MensajeTransicion
      color="success"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />

    <!-- MODAL CONFIRMACIÓN DE OPCIONES DE GUARDADO -->
    <v-dialog v-model="dialogopcionesguardar" max-width="480px" persistent>
      <v-card class="rounded-lg elevation-4 overflow-hidden">
        <v-toolbar color="secondary" dark dense flat height="50" class="px-3">
          <v-icon left small>mdi-content-save-all</v-icon>
          <span class="text-subtitle-1 font-weight-bold"
            >Confirmar Guardado</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="dialogopcionesguardar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4 pt-5">
          <p class="text-body-2 mb-3">
            Se registrarán los siguientes movimientos en el vehículo:
          </p>

          <div class="d-flex flex-wrap mb-3">
            <v-chip
              small
              color="teal lighten-5"
              text-color="teal darken-3"
              class="font-weight-bold mr-2 mb-2"
            >
              <v-icon left small color="teal"
                >mdi-arrow-down-bold-circle</v-icon
              >
              {{ arrayneumaticoposicioninstalar.length }} Neumático(s)
              Instalados
            </v-chip>

            <v-chip
              small
              color="amber lighten-5"
              text-color="amber darken-4"
              class="font-weight-bold mb-2"
            >
              <v-icon left small color="amber darken-3"
                >mdi-arrow-up-bold-circle</v-icon
              >
              {{ arrayneumaticoposiciondesinstalar.length }} Neumático(s)
              Retirados
            </v-chip>
          </div>

          <v-alert type="info" text dense class="text-caption mb-0">
            Seleccione <strong>"Guardar"</strong> para aplicar los cambios y
            permanecer en esta vista, o <strong>"Guardar y salir"</strong> para
            volver al listado de vehículos.
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions
          class="bg-actions pa-3 px-4 d-flex flex-wrap align-center"
        >
          <v-btn
            text
            color="grey darken-1"
            class="text-capitalize"
            @click="dialogopcionesguardar = false"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            outlined
            class="text-capitalize px-3 mr-2"
            @click="guardarInstalacion('guardar')"
            :loading="loadingGuardar"
          >
            <v-icon left small>mdi-content-save-outline</v-icon>
            Guardar
          </v-btn>
          <v-btn
            color="primary"
            elevation="1"
            class="px-4"
            @click="guardarInstalacion('guardarYsalir')"
            :loading="loadingGuardarySalir"
          >
            <v-icon left small>mdi-check-all</v-icon>
            Guardar y salir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TablaNeumaticos from "../components/NeumaticoVerticalTable.vue";
import MensajeTransicion from "../components/Alerta.vue";
import Nuevo from "../components/instalacionneumaticos/nuevo.vue";
import Retiro from "../components/instalacionneumaticos/retiro.vue";
import Imagen from "../components/NeumaticoImageButton.vue";
import router from "@/router";
import global from "../global";

import { mapState, mapActions } from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";

export default {
  components: {
    TablaNeumaticos,
    Imagen,
    Nuevo,
    Retiro,
    MensajeTransicion,
  },
  data() {
    return {
      global: global,
      labelKM: "",
      ItemsNeumaticos: [],
      //ItemsHistorial: [],
      ItemsPosicion: [],
      Cabecera: [
        {
          text: "",
          value: "num_serie",
          align: "center",
          width: "100",
        },
      ],
      limite: 0,
      TituloModal: "",
      dialognuevo: false,
      dialogretiro: false,
      seleccionado: {
        km_instalacion: null,
        fecha_instalacion: null,
      },
      neumaticoSelected: null,
      posicionSeleccionada: null,
      arrayneumaticoposicioninstalar: [],
      arrayneumaticoposiciondesinstalar: [],
      secuenciados: [
        {
          posicion: 2,
          text: 2,
        },
      ],
      secuenciauno: [
        {
          posicion: 1,
          text: 1,
        },
      ],
      fila_1: [6, 10, 14, 18, 22],
      fila_2: [2, 4, 8, 12, 16, 20],
      fila_3: [1, 3, 7, 11, 15, 19],
      fila_4: [5, 9, 13, 17, 21],
      mostrarNeumaticos: false,
      mostrarTablaInstalacion: true,
      pos_inicial: null,
      loader: false,
      dialogopcionesguardar: false,
      loadingGuardar: false,
      loadingGuardarySalir: false,
      mensaje: "",
      verAlerta: false,
      validacioncorrectafecha: false,
      validacioncorrectakm: false,
      validacioncorrectaduplicidad: false,
      mensajevalidacionduplicidad: false,
      mensajevalidacionfecha: "",
      mensajevalidacionkm: "",
      total: 0,
      data: [],
      per_page: 5,
      page: 1,
      from: 1,
      to: 5,
      sortBy: "id",
      sortDirection: "desc",
      loading: true,
    };
  },
  computed: {
    ...mapState("vehiculo", ["ItemInstalacion"]),
  },
  methods: {
    //...mapActions({actualizarItemNeumatico: "vehiculo/actualizarItemNeumatico"}),

    ...mapActions("inspeccion", [
      "validarFecha",
      "validarKm",
      "validarDuplicidad",
    ]),
    ...mapActions("vehiculo", [
      "cargarDatosInstalacion",
      "actualizarItemNeumatico",
      "guardarDatosInstalacion",
    ]),

    onValidarDuplicidad: async function () {
      this.ItemInstalacion.fechainstalacion =
        document.getElementById("fechainstalacion").value;
      if (
        this.ItemInstalacion.fechainstalacion != null &&
        this.ItemInstalacion.fechainstalacion != "" &&
        this.ItemInstalacion.id != "" &&
        this.ItemInstalacion.kilometraje != "" &&
        this.ItemInstalacion.fechainstalacion != ""
      ) {
        this.$emit(
          "fechavalida",
          global._validar_fecha(this.ItemInstalacion.fechainstalacion),
        );

        let mensaje = await this.validarDuplicidad({
          id_vehiculo: this.ItemInstalacion.id,
          km_inspeccion: this.ItemInstalacion.kilometraje,
          fecha_inspeccion: this.ItemInstalacion.fechainstalacion,
        });
        if (mensaje == "") {
          this.mensajevalidacionduplicidad = "";
          this.validacioncorrectaduplicidad = false;
        } else {
          this.mensajevalidacionduplicidad =
            mensaje === "Error de validación" ? "" : mensaje;
          this.validacioncorrectaduplicidad =
            mensaje === "Error de validación" ? false : true;
        }
      } else {
        this.mensajevalidacionduplicidad = "";
        this.validacioncorrectaduplicidad = false;
      }
    },

    onValidarFecha: async function () {
      this.validacioncorrectafecha = false;
      this.mostrarNeumaticos = false;
      this.arrayneumaticoposicioninstalar = [];
      this.arrayneumaticoposiciondesinstalar = [];
      this.ItemsPosicion = [];
      const fechaEl = document.getElementById("fechainstalacion");
      if (fechaEl && fechaEl.value) {
        this.ItemInstalacion.fechainstalacion = fechaEl.value;
      }
      if (
        this.ItemInstalacion.fechainstalacion != null &&
        this.ItemInstalacion.fechainstalacion != ""
      ) {
        this.$emit(
          "fechavalida",
          global._validar_fecha(this.ItemInstalacion.fechainstalacion),
        );
        let resultado = await this.validarFecha({
          id_vehiculo: this.ItemInstalacion.id,
          fecha_inspeccion: this.ItemInstalacion.fechainstalacion,
        });
        if (!resultado.status) {
          this.mensajevalidacionfecha = resultado.message || "";
          this.validacioncorrectafecha = false;
        } else {
          this.mensajevalidacionfecha = "";
          this.validacioncorrectafecha = true;
          if (this.validacioncorrectakm) {
            await this.onCargar();
          }
        }
      } else {
        this.mensajevalidacionfecha = "";
        this.validacioncorrectafecha = true;
        if (this.validacioncorrectakm) {
          await this.onCargar();
        }
      }
    },

    onValidarKm: async function () {
      this.validacioncorrectakm = false;
      this.mostrarNeumaticos = false;
      this.arrayneumaticoposicioninstalar = [];
      this.arrayneumaticoposiciondesinstalar = [];
      this.ItemsPosicion = [];
      const fechaEl = document.getElementById("fechainstalacion");
      if (fechaEl && fechaEl.value) {
        this.ItemInstalacion.fechainstalacion = fechaEl.value;
      }
      if (
        this.ItemInstalacion.kilometraje != null &&
        this.ItemInstalacion.kilometraje !== "" &&
        !isNaN(parseInt(this.ItemInstalacion.kilometraje))
      ) {
        let resultado = await this.validarKm({
          id_vehiculo: this.ItemInstalacion.id,
          km_inspeccion: this.ItemInstalacion.kilometraje,
        });
        if (!resultado.status) {
          this.mensajevalidacionkm = resultado.message || "";
          this.validacioncorrectakm = false;
        } else {
          this.mensajevalidacionkm = "";
          this.validacioncorrectakm = true;
          if (this.validacioncorrectafecha) {
            await this.onCargar();
          }
        }
      } else {
        this.mensajevalidacionkm = "";
        this.validacioncorrectakm = true;
        if (this.validacioncorrectafecha) {
          await this.onCargar();
        }
      }
    },

    labelKilometrosInstalacion: function () {
      this.labelKM =
        this.ItemInstalacion.tipo_costo == 1
          ? "Kilometraje de Vehículo"
          : "Horas de Vehículo";
    },

    async onCargar() {
      const fechaEl = document.getElementById("fechainstalacion");
      if (fechaEl && fechaEl.value) {
        this.ItemInstalacion.fechainstalacion = fechaEl.value;
      }
      this.ItemInstalacion.fechainstalacion = global._validar_fecha(
        this.ItemInstalacion.fechainstalacion,
      );
      if (
        this.ItemInstalacion.fechainstalacion != null &&
        this.ItemInstalacion.kilometraje != null &&
        this.ItemInstalacion.fechainstalacion !== "" &&
        this.ItemInstalacion.kilometraje !== ""
      ) {
        this.loader = true;
        await this.cargarDatosNeumaticosPosicionHistorial({
          page: 1,
          per_page: 5,
          search: "",
          sortBy: "id",
          sortDirection: "desc",
        });

        this.mostrarNeumaticos = true;
      }
    },

    existeposicion: function (pos, array) {
      let datos = null;
      if (
        array &&
        array[pos] &&
        array[pos].ubicacion == pos &&
        array[pos].posicion != null
      ) {
        datos = array[pos];
      }
      return datos;
    },

    enviarDatos: function (item) {
      this.neumaticoSelected = {
        ...item,
      };
    },

    seleccionarposicion: function (index, objeto) {
      if (objeto.num_serie != "P" + index) {
        //Retiro de neumatico
        this.posicionSeleccionada = objeto;
        //Si id_historial es null el neumático a retirar no esta registrado en la base de datos
        if (objeto.id_historial != null) {
          this.seleccionado = {
            id_neumaticos: objeto.id_neumaticos,
            id_historial: objeto.id_historial,
            num_serie: objeto.num_serie,
            fecha_instalacion: objeto.fecha_instalacion,
            km_instalacion: objeto.km_instalacion,
            fecha_retiro: this.ItemInstalacion.fechainstalacion, // retiro neumatico
            km_retiro: this.ItemInstalacion.kilometraje, // retiro neumatico
            motivo_retiro: null, // retiro neumatico
            observacion: null,
          };
          this.dialogretiro = true;
        } else {
          this.seleccionado = {
            id_neumaticos: objeto.id_neumaticos,
          };
          this.desinstalarneumatico(objeto);
        }
      } else {
        //Instalacion de neumatico
        if (this.neumaticoSelected != null) {
          //Cambiar el valor que muestra el boton
          this.seleccionado = {
            id_neumaticos: this.neumaticoSelected.id,
            id_historial: null,
            num_serie: this.neumaticoSelected.num_serie,
            fecha_instalacion: this.ItemInstalacion.fechainstalacion, //instalacion de neumatico
            km_instalacion: this.ItemInstalacion.kilometraje, //instalacion de neumatico
            observacion: null,
          };
          this.posicionSeleccionada = objeto;
          this.dialognuevo = true;
        }
      }
    },

    desinstalarneumatico: async function (objeto) {
      //Encontrar si la posicion se encuentra en un objeto del array
      //Si se encuentra, volver a su posicion anterior y volver a habilitar el neumatico
      let posicion = this.arrayneumaticoposicioninstalar.findIndex(
        (el) => el.id_neumaticos == objeto.id_neumaticos,
      );

      if (objeto.id_historial != null) {
        this.arrayneumaticoposiciondesinstalar.push(objeto);
        this.posicionSeleccionada.id_neumaticos = "-";
        this.posicionSeleccionada.num_serie =
          "P" + this.posicionSeleccionada.ubicacion;
        //Con opciones de de desinstlación los neumáticos son deshabilitados
      } else {
        //this.posicionSeleccionada obtiene la referencia del objeto en posicion
        this.posicionSeleccionada.id_neumaticos = "-";
        this.posicionSeleccionada.num_serie = "P" + objeto.ubicacion;
        this.deshabilitarohabilitarneumatico(false);
        this.arrayneumaticoposicioninstalar.splice(posicion, 1);
      }
    },

    deshabilitarohabilitarneumatico: async function (boolean) {
      // let index = this.ItemsNeumaticos.findIndex(
      //     (el) => el.id == this.seleccionado.id_neumaticos
      // );
      // this.ItemsNeumaticos[index].disabled = boolean;
      this.mostrarTablaInstalacion = false;
      await this.$nextTick();
      this.mostrarTablaInstalacion = true;

      this.neumaticoSelected = null;
    },

    instalarneumatico: function (item) {
      this.deshabilitarohabilitarneumatico(true);
      item.posicion = this.posicionSeleccionada.posicion;
      item.ubicacion = this.posicionSeleccionada.ubicacion;
      item.id_ejes = this.posicionSeleccionada.id_ejes;
      this.arrayneumaticoposicioninstalar.push(item);
      this.posicionSeleccionada.num_serie = item.num_serie;
      this.posicionSeleccionada.id_neumaticos = item.id_neumaticos;
      this.posicionSeleccionada.id_historial = item.id_historial;
      this.$forceUpdate();
    },

    openModalOpcionesParaGuardar: function () {
      this.dialogopcionesguardar = true;
    },

    guardarInstalacion: async function (valor) {
      if (valor == "guardar") {
        this.loadingGuardar = true;
      } else {
        this.loadingGuardarySalir = true;
      }

      let datos = {
        id_vehiculo: this.ItemInstalacion.id,
        tipo_costo: this.ItemInstalacion.tipo_costo,
        kilometros: this.ItemInstalacion.kilometraje,
        fecha: this.ItemInstalacion.fechainstalacion,
        neumaticosinstalados: this.arrayneumaticoposicioninstalar,
        neumaticosretirados: this.arrayneumaticoposiciondesinstalar,
      };
      await this.guardarDatosInstalacion(datos)
        .then((res) => {
          this.mensaje = "Neumáticos Retirados/Instalados";
          this.verAlerta = true;
          if (valor == "guardar") {
            setTimeout(() => {
              this.verAlerta = false;
              router.go();
            }, 4000);
          } else {
            setTimeout(() => {
              this.verAlerta = false;
              router.push("/vehiculos");
            }, 2000);
          }
        })
        .catch((error) => {
          this.errorMessage = error.response.data;
          console.error("error!", error);
        });
    },

    cancelarInstalacion: function () {
      if (this.$rutaAnterior === "/ubicaciontemporal") {
        window.history.go(-2);
      } else {
        this.$router.back();
      }
    },

    cargarDatosNeumaticosPosicionHistorial: async function ({
      page = 1,
      per_page = 5,
      search = "",
      sortBy = "id",
      sortDirection = "desc",
    }) {
      try {
        this.loading = true;
        const data = {
          page: page,
          per_page: per_page,
          num_serie: search,
          sortBy: sortBy,
          sortDirection: sortDirection,
        };
        var url = "showDatosNeumaticosPosicionHistorial?";
        for (let dat in data) {
          url = url + `${dat}=${data[dat]}&`;
        }
        const datos = {
          id_cliente: localStorage.getItem("idcliente"),
          vehiculo: this.ItemInstalacion,
        };
        await axios
          .post(url, datos)
          .then((response) => {
            this.ItemsNeumaticos = response.data.success.resultado.neumaticos;
            const idsDeshabilitar = this.arrayneumaticoposicioninstalar.map(
              (n) => n.id_neumaticos,
            );

            this.data = response.data.success.resultado.neumaticos.data.map(
              (n) => {
                if (idsDeshabilitar.includes(n.id)) {
                  return { ...n, disabled: true };
                }
                return n;
              },
            );

            this.total = response.data.success.resultado.neumaticos.total;
            this.per_page = response.data.success.resultado.neumaticos.per_page;
            this.page = response.data.success.resultado.neumaticos.current_page;
            // Calcular `from` y `to` para el footer
            this.from = response.data.success.resultado.neumaticos.from;
            this.to = response.data.success.resultado.neumaticos.to;
            let datos = response.data.success.resultado.posicion;
            if (this.loader) {
              for (let i = 0; i < datos.length; i++) {
                this.ItemsPosicion[datos[i].ubicacion] = datos[i];
              }
              this.loader = false;
            }
            this.loading = false;
            console.log(
              this.data,
              "ItemsPosicion",
              this.arrayneumaticoposicioninstalar,
              this.data,
            );
            //this.ItemsHistorial = response.data.success.resultado.historial
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
          });
      } catch (error) {
        console.log(error, "error cargooo");
      }
    },
  },
  mounted() {
    let id = location.pathname.substr(1).split("/")[2];
    this.cargarDatosInstalacion(id);
  },
};
</script>

<style scoped>
.bg-actions {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.schematic-container {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow-x: auto;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.03);
}

.chassis-table {
  border-collapse: separate;
  border-spacing: 6px;
  margin: 0 auto;
}

.chassis-table td {
  border: none !important;
  vertical-align: middle;
  padding: 3px !important;
}

.empty-cell {
  width: 106px;
  height: 46px;
}

.chassis-spine-row {
  height: 36px;
}

.chassis-spine {
  position: relative;
  height: 18px;
  background: linear-gradient(90deg, #94a3b8, #64748b, #94a3b8);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.spine-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

.tire-pos-btn {
  border-radius: 8px !important;
  transition: all 0.2s ease-in-out !important;
  overflow: hidden;
  background-color: #ffffff !important;
}

.tire-pos-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.tire-empty {
  border: 1.5px dashed #b0bec5 !important;
  background-color: #f8fafc !important;
}

.tire-can-install {
  border: 2px dashed #009688 !important;
  background-color: #e0f2f1 !important;
  animation: pulse-border 1.5s infinite;
}

@keyframes pulse-border {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 150, 136, 0.45);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(0, 150, 136, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 150, 136, 0);
  }
}

.tire-new-install {
  border: 2px solid #009688 !important;
  box-shadow: 0 0 8px rgba(0, 150, 136, 0.35) !important;
}

.badge-new-install {
  position: absolute;
  top: 2px;
  right: 2px;
  background-color: #009688;
  color: #ffffff;
  font-size: 8px;
  font-weight: bold;
  padding: 1px 4px;
  border-radius: 3px;
  line-height: 1;
}

.empty-pos-label {
  font-size: 0.85rem;
  color: #546e7a;
}

.empty-install-hint {
  font-size: 9px;
  color: #00796b;
  font-weight: 700;
  text-transform: uppercase;
}

.opacity-80 {
  opacity: 0.8;
}

.letra-11 {
  font-size: 11px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

.alerta-duplicidad {
  background: linear-gradient(135deg, #fef08a 0%, #fde047 100%) !important;
  border: 1.5px solid #eab308 !important;
  border-left: 6px solid #a16207 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 14px rgba(234, 179, 8, 0.3) !important;
  padding: 10px 14px !important;
  animation: fadeInAlert 0.25s ease-in-out;
}

.alerta-duplicidad ::v-deep .v-alert__wrapper {
  align-items: center;
}

.alerta-duplicidad-badge {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.85);
  border: 1.5px solid #ca8a04;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 5px rgba(161, 98, 7, 0.18);
  margin: 8px !important;
}

.alerta-duplicidad-titulo {
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #854d0e !important;
  margin-bottom: 2px;
}

.alerta-duplicidad-texto {
  font-size: 0.94rem;
  font-weight: 700;
  color: #451a03 !important;
  line-height: 1.35;
}
</style>
